import React from 'react';
import { Container, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: '#1c1c1e',
      paddingTop: '2rem',
      paddingBottom: '2rem'
    }}>
      <Container style={{ maxWidth: '800px' }}>
        <div className="text-center mb-4">
          <Link to="/welcome" style={{ textDecoration: 'none' }}>
            <h2 style={{ color: 'white' }}>
              <span role="img" aria-label="logo">📊</span> EchoBrief
            </h2>
          </Link>
        </div>
        
        <Card style={{ backgroundColor: 'rgba(52, 58, 64, 0.9)', border: 'none' }}>
          <Card.Body className="p-4 p-md-5">
            <h1 className="text-white mb-4">Privacy Policy</h1>
            <p className="text-white-50 mb-4">Last updated: January 2025</p>
            
            <div className="text-white-50" style={{ lineHeight: '1.8' }}>
              <h4 className="text-white mt-4 mb-3">1. Information We Collect</h4>
              <p>We collect information you provide directly to us:</p>
              <ul>
                <li><strong>Account Information:</strong> Name, email address, and password when you create an account</li>
                <li><strong>Payment Information:</strong> Processed securely through Stripe; we don't store credit card details</li>
                <li><strong>Content:</strong> Audio/video files and documents you upload for processing</li>
                <li><strong>Usage Data:</strong> How you interact with our Service</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">2. How We Use Your Information</h4>
              <p>We use your information to:</p>
              <ul>
                <li>Provide, maintain, and improve our Service</li>
                <li>Process your uploads and generate transcriptions and summaries</li>
                <li>Send you technical notices, updates, and support messages</li>
                <li>Respond to your comments and questions</li>
                <li>Process payments and prevent fraud</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">3. Data Processing</h4>
              <p>
                When you upload content, it is processed by our AI systems 
                to generate transcriptions and summaries. Your content is:
              </p>
              <ul>
                <li>Encrypted in transit and at rest</li>
                <li>Not used to train AI models</li>
                <li>Automatically deleted from processing servers after completion</li>
                <li>Stored in your account only for your access</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">4. Data Sharing</h4>
              <p>We do not sell your personal information. We may share information with:</p>
              <ul>
                <li><strong>Service Providers:</strong> Third-party services that help us operate (e.g., cloud hosting, payment processing)</li>
                <li><strong>Legal Requirements:</strong> When required by law or to protect rights and safety</li>
                <li><strong>Business Transfers:</strong> In connection with a merger or acquisition</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">5. Data Security</h4>
              <p>
                We implement appropriate technical and organizational measures to protect your data, including:
              </p>
              <ul>
                <li>SSL/TLS encryption for all data in transit</li>
                <li>Encrypted storage for sensitive data</li>
                <li>Regular security assessments</li>
                <li>Access controls and authentication</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">6. Data Retention</h4>
              <p>
                We retain your data for as long as your account is active or as needed to provide services. 
                You can delete your content at any time. Upon account deletion, we will delete your data 
                within 30 days, except where required by law.
              </p>

              <h4 className="text-white mt-4 mb-3">7. Your Rights</h4>
              <p>You have the right to:</p>
              <ul>
                <li>Access and download your data</li>
                <li>Correct inaccurate information</li>
                <li>Delete your account and data</li>
                <li>Object to certain processing</li>
                <li>Data portability</li>
              </ul>

              <h4 className="text-white mt-4 mb-3">8. Cookies</h4>
              <p>
                We use essential cookies to maintain your session and remember your preferences. 
                We do not use tracking cookies for advertising purposes.
              </p>

              <h4 className="text-white mt-4 mb-3">9. Children's Privacy</h4>
              <p>
                Our Service is not directed to children under 13. We do not knowingly collect 
                information from children under 13.
              </p>

              <h4 className="text-white mt-4 mb-3">10. Changes to This Policy</h4>
              <p>
                We may update this Privacy Policy from time to time. We will notify you of 
                significant changes via email or through the Service.
              </p>

              <h4 className="text-white mt-4 mb-3">11. Contact Us</h4>
              <p>
                For questions about this Privacy Policy or our data practices, please contact us at:
                <br />
                Email: privacy@echobrief.com
              </p>
            </div>
            
            <div className="mt-5 text-center">
              <Link to="/welcome" className="btn btn-primary">
                Back to Home
              </Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
